import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

export const useDeliveryCardStyles = makeStyles<Theme, { withBorder?: boolean; isMasked?: boolean }>(() => ({
  root: {
    width: '450px',
    border: ({ withBorder }) => (withBorder ? `1px solid ${Colors.lightGray}` : 'none'),
    borderRadius: '5px',
    padding: '8px 8px 8px 16px',
    '&:hover': {
      border: ({ withBorder, isMasked }) =>
        withBorder && !isMasked
          ? `1px solid ${Colors.timelineGray}`
          : isMasked
          ? `1px solid ${Colors.lightGray}`
          : 'none'
    }
  },
  iconWrapper: {
    width: '50px',
    paddingTop: '16px !important'
  },
  title: {
    fontWeight: 700,
    fontSize: '14px',
    marginBottom: '4px'
  },
  descriptionList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    '& li': {
      lineHeight: '20px'
    }
  },
  descriptionText: {
    color: Colors.midLightGray,
    fontSize: '14px',
    fontWeight: 500
  }
}));
